// src/main.js
import Vue from "vue";
import App from "./App.vue";
import router from "./router"; // 这会自动导入 router/index.js
import "./styles/style.scss";
import "amfe-flexible";
import Vant from "vant";
import utils from "./utils";
import Meta from "vue-meta";
import "vant/lib/index.css";

Vue.use(Meta);

Vue.config.productionTip = false;
Vue.use(Vant);
Vue.use(utils);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
